import { Box, Typography } from "@mui/material";
import { nawyTheme } from "@/styles/nawy-theme/nawy-theme";
import AlertIcon from "@/modules/common/components/ui-kit/icons/alert-icon";
import { TaskAiClassification, TaskAiEvaluationResponse } from "@/modules/common/types";

interface TaskAiEvaluationDisplayProps {
  evaluation: TaskAiEvaluationResponse;
  sx?: any;
}

const getClassificationBackgroundColor = (classification: TaskAiClassification) => {
  switch (classification) {
    case "Actionable":
      return nawyTheme.nawy.colors.semantic.layer.extension.positiveLight;
    case "Can Be Better":
      return nawyTheme.nawy.colors.semantic.layer.extension.warningLight;
    default:
      return nawyTheme.nawy.colors.semantic.layer.extension.negativeLight;
  }
};

export const TaskAiEvaluationDisplay = ({ evaluation, sx }: TaskAiEvaluationDisplayProps) => {
  return (
    <Box
      sx={{
        backgroundColor: getClassificationBackgroundColor(evaluation.classification),
        borderRadius: nawyTheme.nawy.radius.lg,
        padding: nawyTheme.nawy.spacing.xs,
        display: "flex",
        alignItems: "flex-start",
        gap: nawyTheme.nawy.spacing.xs,
        ...sx,
      }}
    >
      <AlertIcon size={20} />
      <Box sx={{ flex: 1 }}>
        <Typography
          sx={{
            ...nawyTheme.nawy.typography.english.variants.body.sm.semibold,
            color: nawyTheme.nawy.colors.semantic.text.primary,
            mb: nawyTheme.nawy.spacing.xxs,
          }}
        >
          {evaluation.classification || "Unknown"} task
        </Typography>
        <Typography
          sx={{
            ...nawyTheme.nawy.typography.english.variants.body.sm.regular,
            color: nawyTheme.nawy.colors.semantic.text.primary,
            lineHeight: nawyTheme.nawy.typography.english.variants.body.sm.regular.lineHeight,
          }}
        >
          {evaluation.reason || "No reason provided"}
        </Typography>
      </Box>
    </Box>
  );
};

export default TaskAiEvaluationDisplay;
